import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { useRoute, useRouter } from 'vue-router';
import { message, Modal, notification } from 'ant-design-vue';
import {
  delete_customer,
  delete_person_to_costom_by_custom_id,
  update_customer,
} from '@/api/mjstore-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { reactive } from 'vue';
import modalBox from '@/components/form-modal/modal-tools';
import moment from 'moment';
import { RuleObject } from 'ant-design-vue/lib/form/interface';

const router = useRouter();
export const event_obj = mitt();
export const btn_list = [
  {
    name: '详情',
    //type: 'dropdown',
    clazz: 'default',
    cb: (data: any) => {
      router.push({ path: '/business_manage/profile/basic/' + data.id + '/' + data.name });
    },
  },
  {
    name: '修改',
    clazz: 'primary',
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '修改',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'input',
              name: 'name',
              label: '会员姓名',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写会员姓名',
            },
            {
              type: 'input',
              name: 'pinyin',
              label: '拼音',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写拼音',
            },
            {
              type: 'datepicker',
              name: 'join_date',
              label: '建档日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: false,
              format: 'YYYY-MM-DD',
              valueFormat: 'YYYY-MM-DD',
              placeholder: '请填写建档日期',
            },
            {
              type: 'radio',
              name: 'gender',
              label: '性别',
              disabled: false,
              allowClear: true,
              labelKey: 'name',
              valueKey: 'value',
              defaultValue: '',
              placeholder: '请选择性别',
            },
            {
              type: 'datepicker',
              name: 'birthday',
              label: '生日',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: false,
              format: 'YYYY-MM-DD',
              valueFormat: 'YYYY-MM-DD',
              placeholder: '请填写生日',
            },
            {
              type: 'input',
              name: 'phone',
              label: '电话',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写电话',
            },
            {
              type: 'remoteselect',
              name: 'hk_type_id',
              label: '获客方式',
              disabled: false,
              placeholder: '请选择获客方式',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-hktype',
            },
            {
              type: 'remoteselect',
              name: 'adviser_id',
              label: '所属顾问',
              disabled: false,
              placeholder: '请选择所属顾问',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'radio',
              name: 'is_checked',
              label: '数据核对',
              disabled: false,
              allowClear: true,
              labelKey: 'name',
              valueKey: 'value',
              defaultValue: '',
              placeholder: '请选择数据核对',
            },
          ],
          rules: {
            phone: [{ pattern: /^1[3456789]\d{9}$/, message: '请填输入正确的电话号' }],
            name: [{ required: true, message: '请填输入会员姓名' }],
            join_date: [{ required: true, message: '请输入建档日期' }],
            gender: [{ required: true, message: '请选择性别' }],
            birthday: [{ required: true, message: '请输入出生日期' }],
            shop_id: [{ required: true, message: '请输入会籍' }],
            hk_type_id: [{ required: true, message: '请输入获客方式' }],
            adviser_id: [{ required: true, message: '请选择所属顾问' }],
          },
          model: {
            org_id: current_org?.id,
            is_active: true,
            name: null,
            join_date: null,
            adviser_id: null,
            gender: null,
            birthday: null,
            phone: null,
            shop_id: current_shop?.id,
            hk_type_id: null,
            pinyin: null,
            ...record,
          },
        },
        options: {
          gender: [
            { value: 0, name: '女' },
            { value: 1, name: '男' },
          ],
          is_checked: [
            { value: true, name: '已完成' },
            { value: false, name: '未完成' },
          ],
        },
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            update_customer({
              ...payload,
              org_id: current_org?.id,
              customer_id: record?.id,
            })
              .then(res => {
                notification.success({
                  message: '成功',
                  description: '修改成功',
                });
                Object.assign(record, res);
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '解绑',
    //type: 'dropdown',
    clazz: 'primary',
    cb: (record: any) => {
      if (!record.persontocostom__person_id) {
        Modal.warning({
          title: '提示',
          content: '会员尚未绑定，无需解绑',
        });
      } else {
        Modal.confirm({
          title: '提示',
          content: '是否解绑?',
          onOk() {
            const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
            delete_person_to_costom_by_custom_id({
              customer_id: record.id,
              org_id: current_org?.id,
            }).then(() => {
              message.success('解绑成功');
              record.persontocostom__name = '';
            });
          },
          onCancel() {},
        });
      }
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
